export default __webpack_public_path__ + "static/media/Frame 1.8bfef9c2.png";